import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  custom: {
    color: '#91a2b9',
    animationDuration: '550ms',
  },
}));

export default function CustomSpinner() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress
        variant="indeterminate"
        disableShrink
        className={classes.custom}
        size={49.5}
        thickness={2}
      />
    </div>
  );
}
